import classes from "./CustomTooltip.module.css";
import { IconButton } from "@mui/material";
import Icons from "../../../../resources/icons/Icons";
import Typography from "@mui/material/Typography";
import { HtmlTooltip  } from "../HtmlTooltip/HtmlTooltip";

const CustomTooltip = ({ className, ...props }) => {
  return (
    <HtmlTooltip 
      placement="top-start"
        title={
          <>
            <img
              src={Icons.QUESTION_CIRCLE}
              style={{ float: "left" }}
              className={classes.qs_circle}
            />
            <Typography
              color="inherit"
              gutterBottom={true}
              style={{ marginLeft: "25px" }}
            >
              {props.tooltipTitle}
            </Typography>
            {(<div className={classes.tooltipText} >
                {props.tooltipText}
            </div>)
            }
          </>
        }
        style={ props.isOutOfField ? {display: "flex", width:"10%", marginTop: "20px"} : null  }
      >
      <IconButton sx={props.tooltipButtonSx ? props.tooltipButtonSx : null}>
        <img src={Icons.QUESTION_CIRCLE} className={classes.qs_circle} />
      </IconButton>
    </HtmlTooltip>
  );
};

export default CustomTooltip;
